module.exports = __webpack_public_path__ + "img/IMG_9458_59_60_L_WoodMatted.6ee5112e.jpg";